/* projects/speaker-platform/src/app/app.component.scss */
.app {
  display: grid;
  max-width: 1395px;
  margin: 10px auto;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: max-content 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
}
.app--full-page .app__sidebar {
  grid-area: 1/1/2/4;
}
.app--full-page .app__sidebar--expanded {
  position: absolute;
  z-index: 6;
}
.app--full-page .app__title {
  grid-area: 1/4/2/13;
}
.app--full-page .app__content {
  grid-area: 2/1/3/13;
}
.app__sidebar {
  grid-area: 1/1/3/4;
}
.app__pagetitle {
  grid-area: 1/4/2/13;
}
.app__content {
  grid-area: 2/4/3/13;
}
.applogin {
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=app.component-6QWHTTRV.css.map */
